import React from 'react'
import { TransfersHistoryTable } from '../../../components/transactionNew/transfer/TransferHistoryTable'
import { RTransfersHistoryTable } from '../../../components/transactionNew/transfer/RTransferHistoryTable'
import { MOBILE_SIZE } from '../../../core/constants/common'
import { useWindowSize } from '../../../modules/staking'

const InternalTransferHistory = () => {
    const { width } = useWindowSize()

    return (
        <> {width > MOBILE_SIZE ? <TransfersHistoryTable /> : <RTransfersHistoryTable />} </>
    )
}

export default InternalTransferHistory